import { ElementMatcher } from './common/ElementMatcher';
import { Store } from './common/Store';
export class Dismissable {
    constructor(win = window, store = Store.fromWindow(win)) {
        this.win = win;
        this.store = store;
        this.storageKey = 'dismissables';
    }
    activate() {
        const doc = this.win.document;
        doc.addEventListener('click', (event) => {
            ElementMatcher.emittedByOrChild(event, '[data-dismiss]', (e) => this.handleDismissClick(e));
        });
        Array.from(doc.querySelectorAll('[data-dismissable-storage]'))
            .filter(element => element instanceof HTMLElement)
            .forEach(element => this.showDismissable(element));
    }
    handleDismissClick(dismissElement) {
        const dismissValue = dismissElement.dataset.dismiss;
        const target = dismissValue
            ? ElementMatcher.findParentOrSelf(dismissElement, `[data-dismissable="${dismissValue}"]`)
            : ElementMatcher.findParentOrSelf(dismissElement, '[data-dismissable]');
        if (target) {
            this.removeElement(target);
            this.storeDismissed(target);
        }
    }
    removeElement(element) {
        if (element.classList.contains('show')) {
            element.addEventListener('transitionend', () => { element.remove(); }, { once: true });
            element.classList.remove('show');
        }
        else {
            element.remove();
        }
    }
    showDismissable(element) {
        if (!this.wasClosed(element)) {
            element.classList.remove('hide');
        }
    }
    wasClosed(element) {
        const key = this.getStorageKey(element);
        if (!key)
            return false;
        const dismissedAt = this.store.local.getDateDeep(this.storageKey, key);
        return !!dismissedAt;
    }
    storeDismissed(element) {
        const key = this.getStorageKey(element);
        if (key !== undefined) {
            this.store.local.putDeep(this.storageKey, key, new Date());
        }
    }
    getStorageKey(element) {
        return element.dataset.dismissableStorage;
    }
}
